export default {
  path: 'menuItems',
  component: () => import('./MenuItems.vue'),
  children: [
    {
      path: '/',
      component: () => import('./items-hierarchy/ItemsHierarchy.vue'),
      name: 'menuItems'
    },
    {
      path: 'departments/add',
      component: () => import('./departments/DepartmentForm.vue'),
      name: 'addDepartment'
    },
    {
      path: 'departments/:id/edit',
      component: () => import('./departments/DepartmentForm.vue'),
      name: 'editDepartment'
    },
    {
      path: ':departmentId/category/add',
      component: () => import('./categories/CategoryForm.vue'),
      name: 'addDepartmentCategory'
    },
    {
      path: ':departmentId/category/:categoryId',
      component: () => import('./categories/CategoryForm.vue'),
      name: 'editDepartmentCategory'
    },
    {
      path: ':departmentId/:categoryId/item/add',
      component: () => import('./items/ItemForm.vue'),
      name: 'addDepartmentItem'
    },
    {
      path: ':departmentId/item/:itemId',
      component: () => import('./items/ItemForm.vue'),
      name: 'editDepartmentItem'
    }
  ]
}
